angular.module('FlexyBeautyApp.services')
    .factory('KycRefusedReason', ['gettextCatalog', function (gettextCatalog) {
        return {
            DOCUMENT_UNREADABLE: {
                id: 'DOCUMENT_UNREADABLE',
                label: gettextCatalog.getString("Le document n'est pas lisible (le scan est de mauvaise qualité et le document est flou, tronqué ou il y a un reflet).")
            },
            DOCUMENT_NOT_ACCEPTED: {
                id: 'DOCUMENT_NOT_ACCEPTED',
                label: gettextCatalog.getString("Le document n'a pas été accepté car il ne respecte pas les conditions générales de la certification (non signé, non valide, incomplet).")
            },
            DOCUMENT_HAS_EXPIRED: {
                id: 'DOCUMENT_HAS_EXPIRED',
                label: gettextCatalog.getString("Le document n'est plus valide ou n'est pas à jour (il ne contient pas les dernières modifications).")
            },
            DOCUMENT_INCOMPLETE: {
                id: 'DOCUMENT_INCOMPLETE',
                label: gettextCatalog.getString("Le document est incomplet. Il peut manquer des pages, des signatures ou des changements récents.")
            },
            DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA: {
                id: 'DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA',
                label: gettextCatalog.getString("Le nom associé au compte bancaire ne correspond pas au nom du propriétaire du compte.")
            },
            SPECIFIC_CASE: {
                id: 'SPECIFIC_CASE',
                label: gettextCatalog.getString("Aucune raison standard n’a été détectée pour ce compte.")
            },
            DOCUMENT_FALSIFIED: {
                id: 'DOCUMENT_FALSIFIED',
                label: gettextCatalog.getString("Le document est reconnu comme falsifié.")
            },
            UNDERAGE_PERSON: {
                id: 'UNDERAGE_PERSON',
                label: gettextCatalog.getString("La personne n'a pas l'age légal.")
            },
            DOCUMENT_DO_NOT_MATCH_USER_DATA: {
                id: 'DOCUMENT_DO_NOT_MATCH_USER_DATA',
                label: gettextCatalog.getString("Le nom sur le document d'identité ne correspond pas au nom associé au compte.")
            },
            DOCUMENT_MISSING : {
                id: 'DOCUMENT_MISSING',
                label: gettextCatalog.getString("Le document est manquant.")
            },
            TRIGGER_PEPS : {
                id: 'TRIGGER_PEPS',
                label: gettextCatalog.getString("Autre raison : Veuillez nous contacter.")
            },
            TRIGGER_INTERPOL: {
                id: 'TRIGGER_INTERPOL',
                label: gettextCatalog.getString("Autre raison : Veuillez nous contacter.")
            },
            TRIGGER_SANCTIONS_LISTS: {
                id: 'TRIGGER_SANCTIONS_LISTS',
                label: gettextCatalog.getString("Autre raison : Veuillez nous contacter.")
            }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/KycRefusedReason.js